<template>
  <v-app style="background-color: #f3f6f9">
    <v-main>
      <nav-bar></nav-bar>
      <PortinList />
    </v-main>
  </v-app>
</template>
<script>
import NavBar from '@/components/widgets/navBar.vue'
import PortinList from '@/components/admin/portinPage/PortinList.vue'
import Auth from '@/services/auth.service.js'


export default {
  components: {
    NavBar,
    PortinList
  },
  mounted() {
    document.title = 'Portin | ISRASIM'

    let auth = Auth.checkAuth();
    if (!auth) {
      this.$router.replace({ name: "login" })
    }
  },
}
</script>
  